import type { R, RP } from '@/api';
import LzdAjax from '@/utils/lzd-ajax';
import type { Message } from './model';
import { getAppId, getDataScopeId, getRoleCode } from '@/utils/lzd-util';

const CURR_API_BASE = '/bsl/system/message';

/**
 * 管理查询列表
 */
export async function managerQueryList(param: RP) {
  return LzdAjax.post<Message[]>(
    `${CURR_API_BASE}/manager/query/list`,
    param,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 查询列表
 */
export async function queryPage(param: RP) {
  return LzdAjax.post<Message[]>(
    `${CURR_API_BASE}/query/page`,
    param,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 查询单条数据
 */
export async function querySingleBySeq(seq: number) {
  return querySingle({ pks: [seq] });
}

/**
 * 查询单条数据
 */
export async function querySingle(param: RP) {
  param.appId = getAppId();
  param.dataScopeId = getDataScopeId();
  param.roleCode = getRoleCode();
  return LzdAjax.post<Message>(
    `${CURR_API_BASE}/query/single`,
    param,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 老师发送消息
 */
export async function teacherInsert(data: Message) {
  return LzdAjax.post<unknown>(
    `${CURR_API_BASE}/teacher/insert`,
    data,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 老师批量发送消息
 */
export async function teacherBatchInsert(data: Message[]) {
  return LzdAjax.post<unknown>(
    `${CURR_API_BASE}/teacher/batch/insert`,
    data,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 学生发送消息
 */
export async function studentInsert(data: Message) {
  return LzdAjax.post<unknown>(
    `${CURR_API_BASE}/student/insert`,
    data,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 查询未读的消息
 */
export async function queryUnreadMessage(data: RP) {
  return LzdAjax.post<Record<string, Message[]>>(
    `${CURR_API_BASE}/query/unread`,
    data,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 查询未读的消息
 */
export async function queryUnreadMessageCount(data: RP) {
  return LzdAjax.post<Record<string, number>>(
    `${CURR_API_BASE}/query/unread/count`,
    data,
    false,
    true
  ).then((v) => v.data);
}

/**
 * 已读消息
 */
export async function readMsg(data: RP) {
  return LzdAjax.post<Record<string, Message[]>>(
    `${CURR_API_BASE}/update/read`,
    data,
    false,
    true
  ).then((v) => v.data);
}

class systemMessageApi {
  static queryPage = queryPage;
  static managerQueryList = managerQueryList;
  static teacherInsert = teacherInsert;
  static teacherBatchInsert = teacherBatchInsert;
  static studentInsert = studentInsert;
  static queryUnreadMessage = queryUnreadMessage;
  static readMsg = readMsg;
  static queryUnreadMessageCount = queryUnreadMessageCount;
  static querySingleBySeq = querySingleBySeq;
}
export default systemMessageApi;
